import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import { useTranslation } from 'react-i18next'
import ModalReviewEmail from '@/containers/SubscriptionFormPageNew/Components/ModalSaveAndSend/ModalReviewEmail'
import ModalWhatsappConsent from '@/containers/SubscriptionFormPageNew/Components/ModalSaveAndSend/ModalWhatsappConsent'

const Interactions = ({ hidden }) => {
  const { t } = useTranslation()

  if (hidden) return null

  return (
    <PanelNew title={t('subscriptionForm:header.modal_save_send.interactions_title')} id='InteractionsModule'>
      <ModalReviewEmail />
      <ModalWhatsappConsent />
    </PanelNew>
  )
}

export default Interactions
